import React from 'react';
import { Link } from 'react-router-dom';

const HeroSection: React.FC = () => {
  return (
    <section className="hero">
      <div className="hero-content">
        <p className="hero-subtitle">New Collection 2026</p>
        <h1 className="hero-title">Bold. Beautiful.<br />Handcrafted.</h1>
        <p className="hero-description">
          Every piece is designed and sewn by hand with passion. From beaded fringe to ruched detailing, YIBE brings you one-of-a-kind fashion that celebrates your confidence.
        </p>
        <div className="hero-buttons">
          <Link to="/shop" className="btn btn-primary">Shop Collection</Link>
          <Link to="/shop?category=gowns" className="btn btn-outline">View Gowns</Link>
        </div>
      </div>
      <div className="hero-visual">
        <div className="hero-image-wrapper">
          <img
            src="/images/IMG_1396.jpg"
            alt="YIBE Fashion - Draped Cape Gown"
            className="hero-img"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
